import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
// Copyright   : 2019 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Olli Powroznik, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : slider widget implementation
// =============================================================================
// ---Third-party imports
import React from 'react';
import clsx from 'clsx';
// ---Framework imports
import { isDigit, strip } from 'ldash';
import log from 'uix/logging';
import { Sel } from 'uix/registries';
import { decodeAttribH5 } from 'uix/utils';
import { useSelector, useState } from 'uix/hooks';
// ---Local imports
import HStyles from './banner.scss';
import { wcUrl } from './utils';
// ---Exports
export const BannerHandler = {
    match: ({ tag })=>tag == 'Banner',
    build: ({ attrib })=>{
        let { ids, ...props } = attrib;
        props = decodeAttribH5(props);
        if (ids) {
            props.ids = ids.split(',').map((e)=>strip(e)).filter((e)=>isDigit(e));
        }
        return /*#__PURE__*/ _jsx(Banner, {
            ...props
        });
    }
};
export const Banner = ({ header, subheader, bgimage = 'banner_bg.jpg', ids = [] })=>{
    let apiurl = useSelector(Sel.apiurl);
    let { dname } = useSelector(Sel.request);
    let [index, setIndex] = useState(0);
    let [transition, setTransition] = useState(false);
    let onClickBanner = ()=>{
        setIndex(Math.abs((index + 1) % ids.length));
        setTransition(true);
    };
    let transitionChange = ()=>{
        setTransition(false);
    };
    let url = `${wcUrl(apiurl, 800, ids[index])}`;
    const bg = apiurl.href(`/${dname}/domainimage/${bgimage}`);
    let cssImgUrl = `${url}`;
    const pageImg = {
        backgroundImage: cssImgUrl,
        height: '304px',
        width: 'auto'
    };
    const backgroundImg = {
        backgroundImage: 'url(' + bg + ')'
    };
    return /*#__PURE__*/ _jsx("div", {
        className: HStyles.sliderContainer,
        style: backgroundImg,
        children: /*#__PURE__*/ _jsx("div", {
            className: HStyles.overlayContainer,
            children: /*#__PURE__*/ _jsxs("div", {
                className: HStyles.contentContainer,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: HStyles.textArea,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: HStyles.title,
                                children: header
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: HStyles.subtitle,
                                children: subheader
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: '400px',
                            textAlign: 'center'
                        },
                        children: /*#__PURE__*/ _jsx("img", {
                            src: cssImgUrl,
                            onClick: onClickBanner,
                            onAnimationEnd: transitionChange,
                            className: clsx(HStyles.page, transition && HStyles.faded)
                        })
                    })
                ]
            })
        })
    });
};
